export const chapter4Translations = {
  name: "अध्याय 4: क्रूसीफिक्शन और पुनरुत्थान",
  description: "यीशु के जुनून, मृत्यु और पुनरुत्थान की कहानी का अनुसरण करें",
  spiritualWisdom: "क्रॉस प्रेम की परम जीत और पाप पर विजय का प्रतीक है। पुनरुत्थान हमें मसीह में नई जीवन का वादा देता है।",
  
  levels: {
    40: {
      name: "गिरफ्तारी",
      challenge: "गेथसेमेन में यीशु की गिरफ्तारी के बारे में जानें",
      
      questions: {
        easy: {
          question: "यीशु को किस बगीचे में गिरफ्तार किया गया था?",
          options: ["गेथसेमेन", "ईडन", "जैतून", "नसरत"],
          correctAnswer: 0,
          difficulty: "easy"
        },
        medium: {
          question: "यीशु को धोखा देने के लिए यहूदा ने क्या संकेत इस्तेमाल किया?",
          options: ["एक हाथ मिलाना", "एक चुंबन", "एक शब्द", "एक इशारा"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "किस शिष्य ने अपनी तलवार से महायाजक के सेवक के कान को काट दिया?",
          options: ["याकूब", "यूहन्ना", "पतरस", "अन्द्रियास"],
          correctAnswer: 2,
          difficulty: "hard"
        }
      },
      
      hints: [
        "गेथसेमेन जैतून पर्वत के पैर में एक बगीचा है",
        "यहूदा ने 30 चांदी के सिक्कों के लिए यीशु को धोखा दिया",
        "यीशु ने सेवक के कान को चमत्कारिक रूप से ठीक किया"
      ],
      
      funFacts: [
        "गेथसेमेन का अर्थ है 'तेल प्रेस', जहां जैतून का तेल बनाया जाता था",
        "यीशु की गिरफ्तारी रात के मध्य में हुई थी",
        "यीशु शांतिपूर्वक गया, अपने शिष्यों से हिंसा का विरोध करने के लिए कहा"
      ]
    },

    41: {
      name: "पतरस का इनकार",
      challenge: "पतरस द्वारा यीशु को तीन बार नकारने के बारे में जानें",
      
      questions: {
        easy: {
          question: "पतरस ने यीशु को कितनी बार नकारा?",
          options: ["एक बार", "दो बार", "तीन बार", "चार बार"],
          correctAnswer: 2,
          difficulty: "easy"
        },
        medium: {
          question: "पतरस के तीसरे इनकार के बाद क्या हुआ?",
          options: ["सूरज उगा", "मुर्गा बांग दिया", "बिजली चमकी", "भूकंप आया"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "पतरस कहाँ था जब उसने यीशु को नकारा?",
          options: ["मंदिर में", "महायाजक के आंगन में", "पिलातुस के महल में", "गेथसेमेन में"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "यीशु ने पतरस के इनकार की भविष्यवाणी की थी",
        "पतरस ने कड़वी रोकर पश्चाताप किया",
        "यह सब एक ही रात में हुआ"
      ],
      
      funFacts: [
        "यीशु ने कहा था 'मुर्गा बांग देने से पहले तुम मुझे तीन बार नकारोगे'",
        "पतरस का इनकार मानवीय कमजोरी और ईश्वरीय क्षमा का एक शक्तिशाली उदाहरण है",
        "पतरस बाद में चर्च का एक महान नेता बन गया"
      ]
    },

    42: {
      name: "यीशु पिलातुस के सामने",
      challenge: "यीशु के रोमन गवर्नर के सामने मुकदमे के बारे में जानें",
      
      questions: {
        easy: {
          question: "पिलातुस कौन था?",
          options: ["एक शिष्य", "रोमन गवर्नर", "महायाजक", "फरीसी"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "पिलातुस ने यीशु में क्या नहीं पाया?",
          options: ["बुद्धि", "दोष", "साहस", "शक्ति"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "पिलातुस ने अपनी बेगुनाही का प्रतीक क्या किया?",
          options: ["अपने हाथ धोए", "अपना वस्त्र फाड़ा", "उपवास किया", "प्रार्थना की"],
          correctAnswer: 0,
          difficulty: "hard"
        }
      },
      
      hints: [
        "पिलातुस यीशु को रिहा करना चाहता था",
        "भीड़ ने यीशु की क्रूसीफिक्शन की मांग की",
        "पिलातुस ने राजनीतिक दबाव में झुक गया"
      ],
      
      funFacts: [
        "पिलातुस की पत्नी ने उसे यीशु के खिलाफ कुछ न करने की चेतावनी दी",
        "हाथ धोना यहूदी परंपरा में बेगुनाही का एक प्रतीक था",
        "पिलातुस का निर्णय ने मानव न्याय की विफलता को दिखाया"
      ]
    },

    43: {
      name: "बरब्बा या यीशु",
      challenge: "भीड़ के बरब्बा को चुनने के बारे में जानें",
      
      questions: {
        easy: {
          question: "बरब्बा क्या था?",
          options: ["एक शिष्य", "एक डाकू", "एक पुजारी", "एक राजा"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "यहूदी त्योहार के दौरान पिलातुस क्या कर सकता था?",
          options: ["एक कैदी को रिहा करना", "कर माफ करना", "एक दावत देना", "मंदिर बंद करना"],
          correctAnswer: 0,
          difficulty: "medium"
        },
        hard: {
          question: "भीड़ ने किसे चुना?",
          options: ["यीशु", "बरब्बा", "दोनों", "कोई नहीं"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "यह फसह का त्योहार था",
        "भीड़ ने यीशु को क्रूस पर चढ़ाने की मांग की",
        "बरब्बा एक हत्यारा और विद्रोही था"
      ],
      
      funFacts: [
        "बरब्बा का नाम का अर्थ है 'पिता का पुत्र'",
        "बरब्बा की रिहाई मसीह के बलिदान का एक प्रतीक है",
        "हम सभी बरब्बा हैं, यीशु के बलिदान से मुक्त"
      ]
    },

    44: {
      name: "कोड़े लगाना और कांटों का मुकुट",
      challenge: "यीशु की पीड़ा के बारे में जानें",
      
      questions: {
        easy: {
          question: "सैनिकों ने यीशु के सिर पर क्या रखा?",
          options: ["एक सुनहरा मुकुट", "कांटों का मुकुट", "फूलों की माला", "एक पगड़ी"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "सैनिकों ने यीशु का मजाक कैसे उड़ाया?",
          options: ["उसे एक राजा कहकर", "उसे पत्थर मारकर", "उसे जेल में डालकर", "उसे अनदेखा करके"],
          correctAnswer: 0,
          difficulty: "medium"
        },
        hard: {
          question: "रोमन कोड़े में क्या होता था?",
          options: ["चमड़े की पट्टियां", "हड्डी और धातु के टुकड़े", "केवल लकड़ी", "रस्सी"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "कोड़े लगाना एक क्रूर रोमन दंड था",
        "सैनिकों ने यीशु को बैंगनी वस्त्र पहनाया",
        "यीशु ने यह सब शांति से सहन किया"
      ],
      
      funFacts: [
        "कांटों का मुकुट पाप के अभिशाप का प्रतीक है",
        "बैंगनी रंग राजसी रंग था, मजाक के रूप में इस्तेमाल किया गया",
        "यीशु की पीड़ा यशायाह की भविष्यवाणियों को पूरा करती है"
      ]
    },

    45: {
      name: "गोलगोथा की ओर मार्ग",
      challenge: "यीशु के क्रूस को ले जाने के बारे में जानें",
      
      questions: {
        easy: {
          question: "यीशु ने क्या ले जाया?",
          options: ["एक झंडा", "एक क्रूस", "एक ताज", "एक तलवार"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "किसने यीशु को क्रूस ले जाने में मदद की?",
          options: ["पतरस", "यूहन्ना", "कुरेने का शमौन", "यूसुफ"],
          correctAnswer: 2,
          difficulty: "medium"
        },
        hard: {
          question: "गोलगोथा का क्या अर्थ है?",
          options: ["पवित्र पर्वत", "खोपड़ी का स्थान", "शांति का स्थान", "न्याय का स्थान"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "यीशु कमजोर होकर गिर गया था",
        "महिलाएं रास्ते में रो रही थीं",
        "यह जुलूस शहर से होकर गुजरा"
      ],
      
      funFacts: [
        "क्रूस का वजन लगभग 40-50 किलो था",
        "गोलगोथा शहर की दीवारों के बाहर था",
        "कुरेने का शमौन अफ्रीका से आया था"
      ]
    },

    46: {
      name: "क्रूसीफिक्शन",
      challenge: "यीशु के क्रूस पर चढ़ाए जाने के बारे में जानें",
      
      questions: {
        easy: {
          question: "यीशु को कितने अन्य लोगों के साथ क्रूस पर चढ़ाया गया?",
          options: ["कोई नहीं", "एक", "दो", "तीन"],
          correctAnswer: 2,
          difficulty: "easy"
        },
        medium: {
          question: "क्रूस पर यीशु ने क्या कहा: 'पिता, उन्हें ___'?",
          options: ["बचाओ", "क्षमा करो", "रोको", "सजा दो"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "क्रूस पर लिखा शिलालेख क्या था?",
          options: ["पापी", "यहूदियों का राजा", "विद्रोही", "नबी"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "यीशु दोपहर के तीसरे घंटे में क्रूस पर चढ़ाया गया",
        "सैनिकों ने उसके कपड़ों के लिए चिट्ठी डाली",
        "यीशु ने सात वाक्य क्रूस से बोले"
      ],
      
      funFacts: [
        "शिलालेख तीन भाषाओं में लिखा था: हिब्रू, लैटिन, और ग्रीक",
        "एक डाकू ने अंतिम क्षण में पश्चाताप किया",
        "यीशु ने अपनी माँ की देखभाल यूहन्ना को सौंपी"
      ]
    },

    47: {
      name: "यीशु की मृत्यु",
      challenge: "यीशु की अंतिम घड़ियों के बारे में जानें",
      
      questions: {
        easy: {
          question: "यीशु की मृत्यु के समय क्या हुआ?",
          options: ["सूर्य चमकीला हो गया", "अंधेरा छा गया", "बारिश हुई", "इंद्रधनुष दिखाई दिया"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "मंदिर में क्या फट गया?",
          options: ["फर्श", "परदा", "दीवार", "छत"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "यीशु के अंतिम शब्द क्या थे?",
          options: ["यह समाप्त हुआ", "मैं प्यासा हूं", "पिता, मेरी आत्मा तेरे हाथों में", "क्यों मुझे छोड़ दिया"],
          correctAnswer: 2,
          difficulty: "hard"
        }
      },
      
      hints: [
        "अंधेरा तीन घंटे तक रहा",
        "एक सैनिक ने यीशु के पहलू को भाला से छेदा",
        "एक शताब्दी ने कहा 'सचमुच यह ईश्वर का पुत्र था'"
      ],
      
      funFacts: [
        "मंदिर का परदा ऊपर से नीचे तक फट गया, मानवीय हाथ से नहीं",
        "यह फसह के समय हुआ, जब मेमने की बलि दी जाती थी",
        "यीशु की मृत्यु ने पाप की मजदूरी का भुगतान किया"
      ]
    },

    48: {
      name: "दफन",
      challenge: "यीशु के दफन के बारे में जानें",
      
      questions: {
        easy: {
          question: "यीशु को किसकी कब्र में रखा गया?",
          options: ["पतरस", "अरिमथिया का यूसुफ", "निकोडेमस", "लाजर"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "यीशु के शरीर को किसमें लपेटा गया?",
          options: ["बैंगनी वस्त्र में", "सुनहरे वस्त्र में", "सफेद चादर में", "कोई वस्त्र नहीं"],
          correctAnswer: 2,
          difficulty: "medium"
        },
        hard: {
          question: "निकोडेमस यीशु के शरीर के लिए क्या लाया?",
          options: ["तेल", "मसाले और मुर", "पानी", "फूल"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "कब्र एक नई चट्टान में खोदी गई थी",
        "एक बड़ा पत्थर प्रवेश को बंद कर दिया गया",
        "पहरेदार कब्र की रखवाली के लिए तैनात किए गए"
      ],
      
      funFacts: [
        "यह एक अमीर आदमी की कब्र थी, यशायाह की भविष्यवाणी को पूरा करते हुए",
        "दफन जल्दी से किया गया क्योंकि सब्बाथ आ रहा था",
        "यूसुफ एक गुप्त शिष्य था जो साहसी हो गया"
      ]
    },

    49: {
      name: "खाली कब्र",
      challenge: "पुनरुत्थान की सुबह की खोज के बारे में जानें",
      
      questions: {
        easy: {
          question: "कब्र को पहले किसने खाली पाया?",
          options: ["पतरस", "यूहन्ना", "महिलाएं", "सैनिक"],
          correctAnswer: 2,
          difficulty: "easy"
        },
        medium: {
          question: "पत्थर कहाँ था?",
          options: ["टूटा हुआ", "लुढ़का हुआ", "वहीं पर", "गायब"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "महिलाओं को कब्र में कितने स्वर्गदूत मिले?",
          options: ["कोई नहीं", "एक", "दो", "तीन"],
          correctAnswer: 2,
          difficulty: "hard"
        }
      },
      
      hints: [
        "यह सप्ताह के पहले दिन की सुबह थी",
        "महिलाएं यीशु के शरीर का अभिषेक करने आई थीं",
        "स्वर्गदूतों ने सुसमाचार की घोषणा की"
      ],
      
      funFacts: [
        "महिलाएं पहली गवाह थीं, एक क्रांतिकारी विवरण",
        "पतरस और यूहन्ना कब्र तक दौड़े",
        "खाली कब्र ही पर्याप्त नहीं थी, यीशु को दिखाई देना था"
      ]
    },

    50: {
      name: "यीशु मरियम मगदलीनी को दिखाई देते हैं",
      challenge: "यीशु के पहले प्रकट होने के बारे में जानें",
      
      questions: {
        easy: {
          question: "यीशु ने पुनरुत्थान के बाद पहले किसे दिखाई दिया?",
          options: ["पतरस", "यूहन्ना", "मरियम मगदलीनी", "थोमा"],
          correctAnswer: 2,
          difficulty: "easy"
        },
        medium: {
          question: "मरियम ने पहले यीशु को किसके लिए गलती की?",
          options: ["एक स्वर्गदूत", "माली", "एक सैनिक", "एक फरीसी"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "यीशु ने मरियम को क्या कहा जब उसने उसे पहचाना?",
          options: ["जाओ और बताओ", "मुझे मत छुओ", "डरो मत", "विश्वास करो"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "मरियम रो रही थी कब्र के पास",
        "यीशु ने उसका नाम लिया",
        "उसने उसे अपने भाइयों को बताने के लिए भेजा"
      ],
      
      funFacts: [
        "यीशु ने अपने पहले प्रकट होने के लिए एक महिला को चुना",
        "मरियम पहली प्रेरित बन गई",
        "उसने यीशु को 'रब्बूनी' (गुरु) कहा"
      ]
    },

    51: {
      name: "इम्माऊस के रास्ते पर",
      challenge: "सड़क पर यीशु के प्रकट होने के बारे में जानें",
      
      questions: {
        easy: {
          question: "कितने शिष्य इम्माऊस जा रहे थे?",
          options: ["एक", "दो", "तीन", "चार"],
          correctAnswer: 1,
          difficulty: "easy"
        },
        medium: {
          question: "शिष्यों ने यीशु को कब पहचाना?",
          options: ["तुरंत", "रोटी तोड़ते समय", "सड़क पर", "कभी नहीं"],
          correctAnswer: 1,
          difficulty: "medium"
        },
        hard: {
          question: "यीशु ने उन्हें रास्ते में क्या समझाया?",
          options: ["भविष्य", "शास्त्र", "कानून", "चमत्कार"],
          correctAnswer: 1,
          difficulty: "hard"
        }
      },
      
      hints: [
        "यीशु एक अजनबी के रूप में उनके साथ चला",
        "उनका दिल जल रहा था जैसे वह बोलता था",
        "यीशु गायब हो गया जब उन्होंने उसे पहचाना"
      ],
      
      funFacts: [
        "इम्माऊस यरूशलेम से लगभग 11 किलोमीटर दूर था",
        "यीशु ने उन्हें सभी शास्त्रों में उसके बारे में दिखाया",
        "शिष्य तुरंत यरूशलेम वापस दौड़े"
      ]
    },

    52: {
      name: "शिष्यों को प्रकट होना",
      challenge: "बंद कमरे में यीशु के प्रकट होने के बारे में जानें",
      
      questions: {
        easy: {
          question: "शिष्य कहाँ थे जब यीशु दिखाई दिया?",
          options: ["मंदिर में", "बाजार में", "एक बंद कमरे में", "गेथसेमेन में"],
          correctAnswer: 2,
          difficulty: "easy"
        },
        medium: {
          question: "यीशु ने शिष्यों को क्या दिखाया?",
          options: ["उसके घाव", "उसका चेहरा", "उसके कपड़े", "एक प्रकाश"],
          correctAnswer: 0,
          difficulty: "medium"
        },
        hard: {
          question: "कौन सा शिष्य पहली बार गायब था?",
          options: ["पतरस", "यूहन्ना", "थोमा", "याकूब"],
          correctAnswer: 2,
          difficulty: "hard"
        }
      },
      
      hints: [
        "दरवाजे बंद थे डर से",
        "यीशु ने कहा 'तुम्हें शांति मिले'",
        "उसने उन पर फूंका और कहा 'पवित्र आत्मा प्राप्त करो'"
      ],
      
      funFacts: [
        "यीशु ने उनके साथ भोजन किया यह साबित करने के लिए कि वह एक भूत नहीं था",
        "थोमा ने एक हफ्ते बाद विश्वास किया",
        "यीशु 40 दिनों तक कई बार दिखाई दिया"
      ]
    }
  }
};
